import "./test.css";
import { LuGithub, LuLinkedin } from "react-icons/lu";
import { Alert, BorderBeam, Button, Card, Divider, Flex, Image, Tag, Typography, type BorderBeamGradient } from "antd";
import { LucaPhoto } from "@/assets";
import Initials from './Initials';

enum SkillType {
    Language,
    Software,
    Other
}

interface Skill {
    name: string,
    type: SkillType
}

export function App() {
    const skills: Skill[] = [
        { name: 'C#', type: SkillType.Language },
        { name: 'C++', type: SkillType.Language },
        { name: 'Rust', type: SkillType.Language },
        { name: 'Unity', type: SkillType.Software },
        { name: 'Blender', type: SkillType.Software },
        { name: 'AR (Augmented Reality)', type: SkillType.Other },
        { name: 'VR (Virtual Reality)', type: SkillType.Other }
    ];

    function openUrl(url: string) {
        window.open(url, "_blank");
    }

    function getColorFromSkillType(type: SkillType): string {
        switch (type) {
            case SkillType.Language:
                return 'magenta';
            case SkillType.Software:
                return 'cyan'
            case SkillType.Other:
                return 'gold'
            default:
                return 'grey';
        }
    }

    return (
        <Flex vertical align="center" justify="center" style={{ width: '100%', height: '95dvh', padding: '0!important', margin: 0 }}>
            <Initials width={50} height={50} style={{ position: 'fixed', top: '1.5em', left: '1.5em' }} />
            <BorderBeam color={'cyan'}>
                <Card style={{ width: '100%', maxWidth: '400px' }}>
                    <Flex justify="center" wrap className={'test'}>
                        <Flex vertical justify="center" align="center" gap={'0px'}>
                            <Image alt="Luca Ruiters" src={LucaPhoto} className={'profile-image'} />
                            <Typography.Title level={2} style={{ marginBlockStart: '0!important', textAlign: 'center', width: '200px' }}>
                                Luca Ruiters
                            </Typography.Title>
                        </Flex>
                        <Divider />
                        <Flex vertical style={{ flexGrow: 1 }}>
                            <Typography.Title level={4}>Skills</Typography.Title>
                            <Flex wrap gap={'0.5em'}>
                                {skills.map(s => <Tag color={getColorFromSkillType(s.type)} title={s.name}>{s.name}</Tag>)}
                            </Flex>
                            <Typography.Title level={4}>Socials</Typography.Title>
                            <Flex gap={'1rem'}>
                                <Button
                                    onClick={() => openUrl('https://github.com/ru1t3rl')}
                                    className={'icon-button'}>
                                    <LuGithub size={50} />
                                </Button>
                                <Button                                color
                                    onClick={() => openUrl('https://linkedin.com/in/luca-ruiters')}
                                    className={'icon-button'}>
                                    <LuLinkedin size={40} />
                                </Button>
                            </Flex>
                        </Flex>
                    </Flex>
                </Card>
            </BorderBeam>
            <Alert
                title={'Coming soon'}
                description={"I'm crafting a new portfolio to showcase my projects, experiments, and ideas. Stay tuned! In the mean time checkout my socials."}
                type='warning'
                closable
                style={{ position: 'fixed', bottom: '1em', width: '95%' }}
            />
        </Flex >
    );
}

export default App;
